export interface MailEntityEvent {
  type: "mail.entity";
  payload: string | null;
}

export interface CrmEntityEvent {
  type: "crm.entity";
  payload: {
    crmId: string;
    emailAddress?: string;
  };
}

/**
 * Union of every standardised platform event flowing through the bridge.
 */
export type PlatformEvent = MailEntityEvent | CrmEntityEvent;

export type PlatformEventType = PlatformEvent["type"];

export type PlatformEventOfType<TType extends PlatformEventType> = Extract<PlatformEvent, { type: TType }>;

export type PlatformEventListener<TType extends PlatformEventType> = (event: PlatformEventOfType<TType>) => void;

interface MailEntityInput {
  emailAddress?: unknown;
}

export function buildMailEntityEvent(input: MailEntityInput): MailEntityEvent {
  const email = typeof input.emailAddress === "string" ? input.emailAddress.trim() : "";

  if (!email || !email.includes("@")) {
    return { type: "mail.entity", payload: null };
  }

  return {
    type: "mail.entity",
    payload: email,
  };
}
